export default {
  open: "Open",
  cleared: "Cleared",
  closed: "Closed",
};
